import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

const PrivateRoute = ({ children }) => {
  const user = useSelector((state) => state?.user?.user);

  if (!user && !localStorage.getItem("userToken")) {
    return <Navigate to="/login" />;
  }

  return children;
};

export default PrivateRoute;
